import AllApprovalsLogs from "./views/AllApprovalsLogs.vue";
import MyLogs from "./views/MyLogs.vue";
export default [
  {
    path: "approvals",
    component: AllApprovalsLogs,
  },

  {
    path: "my-logs",
    component: MyLogs,
  },
];
